<template>
  <div class="protocol-container">
    <div class="protocol-header">
      <h1 class="protocol-title">克里奧數位行銷有限公司</h1>
      <h2 class="protocol-subtitle">服務條款與隱私權保護政策</h2>
    </div>

    <div class="protocol-intro">
      <p>
        為保障您的權益，請在註冊成為本網站會員並使用克里奧數位行銷有限公司所提供之各項會員服務之前，詳細閱讀本服務條款所有內容。尤其當您勾選「同意」後，即視為您已閱讀、了解本服務條款，並同意遵守以下所有服務條款之會員規範。
      </p>
    </div>

    <div class="protocol-section">
      <h2 class="section-title">一、認知與接受條款</h2>
      <div class="section-content">
        <p>
          您瞭解您註冊成為本網站會員後，即可使用克里奧數位行銷有限公司所提供之各項會員服務（以下簡稱本服務），且表示您已閱讀、瞭解並同意接受本服務條款之所有內容。當會員使用本服務時，即表示除了同意遵守本服務條款外，還同意接受克里奧數位行銷有限公司對本網站會員之規範（包括客服中心內容、遊戲規則、公告事項各別服務之規範等）並遵守相關法律規定。
        </p>
        <p>
          若您未滿二十歲，除應符合上述規定外，並應於您的家長（法定代理人或監護人）閱讀、瞭解並同意本服務條款之所有內容及其後修改變更後，方得使用或繼續使用本服務。
        </p>
      </div>
    </div>

    <div class="protocol-section">
      <h2 class="section-title">二、會員服務條款之增訂及修改</h2>
      <div class="section-content">
        <p>
          克里奧數位保留增訂及修改本會員條款之權利，本條款如有增訂或修改時，克里奧數位行銷有限公司將於網站首頁公告修改之事實，對會員不另作個別通知。您如您不同意修改的內容，請勿繼續使用本服務，如果您於公告後繼續使用本服務，則視為您已接受並同意該修訂條款。
        </p>
      </div>
    </div>

    <div class="protocol-section">
      <h2 class="section-title">三、服務介紹</h2>
      <div class="section-content">
        <p>本網站是克里奧數位行銷有限公司提供的遊戲平台，您所購買的點數，將可享受各種符合本網站所提供的遊戲服務。</p>
        <p>接受本服務之會員必須自行配備上網所需之各項電腦設備，以及負擔「網際網路連線費用」、「電話費用」等之電信相關費用。</p>
      </div>
    </div>

    <div class="protocol-section">
      <h2 class="section-title">四、會員責任與義務</h2>
      <div class="section-content">
        <div class="sub-section">
          <h3 class="sub-title">(一) 真實登錄義務</h3>
          <p>
            您同意於註冊時登錄您本人正確、完整且符合真實之個人資料。您所登錄之資料若事後有所變更時，應隨時於線上更新。當所登錄的個人資料，或原登錄之資料已不符合真實而未更新，或有任何誤導之嫌，克里奧數位行銷有限公司將保留隨時終止您會員資格及使用本服務之權利。
          </p>
        </div>

        <div class="sub-section">
          <h3 class="sub-title">(二) 服務使用之責任與義務</h3>
          <ol class="numbered-list">
            <li>會員不得利用本服務進行任何商業行為。</li>
            <li>除了遵守本服務條款外，您同意遵守網際網路國際使用慣例與禮節之相關規定。</li>
            <li>會員不得利用本服務傳送、發表涉及辱罵、毀謗、不雅、淫穢、攻擊性之文章或圖片。</li>
            <li>會員同意必須充分尊重智慧財產權，禁止發表侵害他人各項智慧財產權或其他權利之文字、圖片或任何形式之檔案。</li>
          </ol>
        </div>

        <div class="sub-section">
          <h3 class="sub-title">(三) 帳號保管義務</h3>
          <ol class="numbered-list">
            <li>
              您暸解當您成為本網站會員後得開始使用本服務，其所有權仍屬克里奧數位行銷有限公司所及其所約定之人所有，會員僅得依本服務條款之約定使用，不得出租、出借、移轉或讓與給其他之三人使用。
            </li>
            <li>會員有義務妥善保管本網站帳號、密碼及其他相關之會員資料，並為此組帳號登入系統後所進行之一切活動、行為責負。</li>
            <li>
              若會員發現帳號或密碼遭人非法使用或有任何異常破壞使用安全之情形時，應立即通知克里奧數位行銷有限公司。但若是因您的保管疏忽，而導致帳號、密碼遭他人非法使用時，克里奧數位行銷有限公司將不負責處理。
            </li>
          </ol>
        </div>
      </div>
    </div>

    <div class="protocol-section">
      <h2 class="section-title">五、會員儲值責任限制</h2>
      <div class="section-content">
        <p>本網站會員使用本服務付費項目時所使用之儲值點數，無法取消、更改、退費或轉入其他本網站裡。</p>
        <p>若您使用虛偽不正之方式進行「儲值」，克里奧數位行銷有限公司保留隨時終止您會員資格及使用本服務之權利，並將追究相關法律責任。</p>
      </div>
    </div>

    <div class="protocol-section">
      <h2 class="section-title">六、服務之終止與變更</h2>
      <div class="section-content">
        <p>
          會員若有下列任一情形時，克里奧數位行銷有限公司有權隨時終止或變更任一會員帳號之服務，且無需事先通知會員。就終止或更改會員使用本服務所可能產生之困擾、不便或損害，本服務對任何會員或第三人均不負任何責任。
        </p>
        <ol class="numbered-list">
          <li>會員登錄不實資料進行註冊。</li>
          <li>以克里奧數位行銷有限公司或類似克里奧數位行銷有限公司名稱使用本服務者。</li>
          <li>使用中文、英文及數字以外之字元及不雅文字作為本服務之名稱。</li>
          <li>冒用他人名義申請本服務之帳號。</li>
          <li>使用虛偽不正之方式進行儲值。</li>
          <li>違反本服務條款時。</li>
          <li>違反公共安全、公共秩序與善良風俗之行為時。</li>
          <li>違反現行法律之行為時。</li>
        </ol>
      </div>
    </div>

    <div class="protocol-section">
      <h2 class="section-title">七、服務暫停或中斷</h2>
      <div class="section-content">
        <p>
          於下列情形任一情形發生時，克里奧數位行銷有限公司有權暫停或中斷本服務之全部或一部，對因此而產生之困擾、不便或損害，本服務對任何會員或第三人均不負任何責任。
        </p>
        <ol class="numbered-list">
          <li>對本服務之相關軟硬體設備與電子通信設備進行維修保養及施工時。</li>
          <li>發生非可歸責於本公司突發性之軟硬體設備與電子通信設備故障時。</li>
          <li>因天災等不可抗力之因素致使本服務無法提供服務時。</li>
          <li>在緊急情況下為維護其他會員或第三人的人身、資料之完整安全。</li>
        </ol>
        <p>
          如因使用者違反法令或本服務條款或因不可歸責於克里奧數位行銷有限公司之事由而造成本服務之全部或一部暫停或中斷時，暫停或中斷期間之費用仍依正常標準計費。
        </p>
      </div>
    </div>

    <div class="protocol-section">
      <h2 class="section-title">八、服務變更權利</h2>
      <div class="section-content">
        <p>克里奧數位行銷有限公司將保留新增、修改或刪除本服務之全部或一部之權利，且不另行個別通知，會員不得因此而要求任何補償或賠償。</p>
      </div>
    </div>

    <div class="protocol-section">
      <h2 class="section-title">九、責任範圍</h2>
      <div class="section-content">
        <p>本服務依克里奧數位行銷有限公司既有之規劃提供對於特定使用者之特殊需求，克里奧數位行銷有限公司不擔保本服務將完全符合您的需求。</p>
        <p>
          本服務可能因自身、其他協力廠商或相關電信業者網路系統軟硬體設備之故障或失靈；或人為操作上之疏失而造成中斷、暫時無法使用、遲延、資料傳輸或儲存上之錯誤；或遭第三人侵入系統篡改或偽造變造資料等。克里奧數位行銷有限公司就以上情形不保證各項服務之穩定、安全、無誤、及不中斷。會員需明白使用本服務之所有風險及可能致生之任何損害，不得因此而要求任何補償或賠償。
        </p>
      </div>
    </div>

    <div class="protocol-section">
      <h2 class="section-title">十、會員資料處理與隱私權保護</h2>
      <div class="section-content">
        <p>
          對於會員所登錄或留存之個人資料，您同意克里奧數位行銷有限公司得於合理之範圍內保存、蒐集、處理、傳遞及使用會員個人資料或其衍生之相關電磁錄，以提供會員其他資訊服務，或作成會員統計資料、進行關於網路行為之調查或研究或為任何之合法使用。
        </p>
        <p>
          對於會員所登錄或留存之個人資料，克里奧數位行銷有限公司在未獲會員同意之前，不對外揭露會員之姓名、地址、電子郵件地址及其他依法受保護之個人資料，但下列情況不在此限：
        </p>
        <ol class="numbered-list">
          <li>受司法、警察或其他有權機關基於法定程序之要求時。</li>
          <li>於維護公益或保護克里奧數位行銷有限公司或他人權益時。</li>
          <li>因會員之行為違反法令或本服務條款之規定時。</li>
          <li>在緊急情況下為維護其他會員或第三人之人身、交易內容、遊戲歷程、個人資料之完整安全時。</li>
        </ol>
      </div>
    </div>

    <div class="protocol-section">
      <h2 class="section-title">十一、智慧財產權</h2>
      <div class="section-content">
        <p>
          此網站上之所有著作及資料，其著作權、專利權、商標、營業秘密、其他智慧財產權，所有權或其他權利，均為克里奧數位行銷有限公司或其權利人所有，除事先經克里奧數位行銷有限公司或其各別權利人之合法授權外，會員不得擅自以重製、傳輸、改作、編輯或以其他任何形式、基於任何目的加以使用，違者應自行負所有相關法律責任。
        </p>
      </div>
    </div>

    <div class="protocol-section">
      <h2 class="section-title">十二個別條款之效力</h2>
      <div class="section-content">
        <p>本同意書所定之任何會員條款之全部或部分無效時，不影響其他條款之效力。</p>
      </div>
    </div>

    <div class="protocol-section">
      <h2 class="section-title">十三、準據法</h2>
      <div class="section-content">
        <p>
          本服務條款之解釋及適用，以及會員因使用本服務而與克里奧數位行銷有限公司間所生之權利義務關係，應依中華民國法律解釋適用之（不含涉外民事法律適用法或其他類似法規。）
        </p>
      </div>
    </div>

    <div class="protocol-section">
      <h2 class="section-title">十四、管轄法院</h2>
      <div class="section-content">
        <p>
          因本服務條款而生之爭議，均同意以台北市地方法院為第一審管轄法院；前項約定不排除消費者保護法第四十七條或民事訴訟法第四三六條之九小額訴訟管轄法院之適用。
        </p>
      </div>
    </div>

    <div class="privacy-policy">
      <div class="policy-header">
        <h2 class="policy-title">【個人資料暨隱私權保護政策】</h2>
        <p class="policy-intro">
          克里奧數位行銷有限公司「個人資料隱私權保護政策」聲明：克里奧數位行銷有限公司（以下簡稱克里奧數位）為保障您個人資料之安全性，特針對您個人的隱私權擬定「個人資料隱私權保護政策」聲明（Privacy
          Policy，下簡稱隱私權政策），讓您瞭解克里奧數位對於您的隱私權之尊重與保護，並告訴您有關您個人資料之相關資訊。<br />
          本政策讓您瞭解克里奧數位在蒐集您的個人資料時：<br />
          1.本公司的名稱。<br />
          2.蒐集之目的。<br />
          3.個人資料之類別。<br />
          4.個人資料利用之期間、地區、對象及方式。<br />
          5.您得行使之權利及方式。<br />
          6.若您無法提供完整的個人資料時，不提供將對您權益之影響。<br />
          7.個人資料的安全維護<br />
          請您詳細閱讀克里奧數位行銷有限公司「隱私權政策」<br />
        </p>
      </div>

      <div class="protocol-section">
        <h2 class="section-title">一、適用範圍</h2>
        <div class="section-content">
          <p>
            克里奧數位行銷有限公司「隱私權政策」適用於您在克里奧數位網站內與其所附屬之網站活動時，所涉及的個人資料蒐集、處理、利用、國際傳遞以及保護措施。但不適用於經克里奧數位網站而連結至第三人經營的網站或網頁。
          </p>
        </div>
      </div>

      <div class="protocol-section">
        <h2 class="section-title">二、資料蒐集之目的及類別</h2>
        <div class="section-content">
          <p>根據克里奧數位所提供不同服務目的，克里奧數位行銷有限公司可能蒐集您的個人資料類別及情形如下：</p>
          <div class="sub-section">
            <h3 class="sub-title">(一) 加入會員</h3>
            <p>
              當您申請加入會員時，您將會被要求填寫一份您的個人資料，包括姓名、性別、身份證字號、住址、生日、電話、電子信箱、職業等相關必要資料，成為會員後，您將會獲得一個會員的帳號與密碼，並由本組帳號、密碼登入使用會員的各項服務。
            </p>
          </div>
          <div class="sub-section">
            <h3 class="sub-title">(二) 線上交易</h3>
            <p>
              如您選擇使用線上交易服務，將會依照你提出的線上交易形態，蒐集您所填寫的訂單相關資料，以確保您完成付款、儲值或物流等消費服務。
            </p>
          </div>
          <div class="sub-section">
            <h3 class="sub-title">(三) 線上活動</h3>
            <p>
              您若因參加克里奧數位舉辦之線上活動或網路調查而登入會員帳號與密碼時，關於您個人資料將直接由會員資料庫提供。惟若該項活動仍需您配合補充相關資料時，請詳細登錄所需之資料。惟該此補充資料，亦一併受到隱私權政策之保護。
            </p>
          </div>
          <div class="sub-section">
            <h3 class="sub-title">(四) 瀏覽網頁</h3>
            <p>
              當您於克里奧數位站內或其附屬網站中瀏覽或查詢時，克里奧數位伺服器將自動紀錄您使用連線之IP位置、時間及瀏覽相關記錄。這些資料僅供作流量統計分析及網路服務優化，以便於改善克里奧數位的服務品質，這些資料僅作為總量上的分析，不會和特定個人相連繫。
            </p>
          </div>
          <div class="sub-section">
            <h3 class="sub-title">(五) 其他</h3>
            <p>
              除了您直接提供的個人資料之外，您也可能在克里奧數位合作廠商處主動提供個人資料，並在您同意或為履行契約目的前提下，將您的個人資料提供給克里奧數位。這些資料只會在您同意或為履行契約的服務範圍內利用及處理，不會用於其他用途。
            </p>
          </div>
        </div>
      </div>

      <div class="protocol-section">
        <h2 class="section-title">三、資料利用之期間、地區、對象及方式</h2>
        <div class="section-content">
          <div class="sub-section">
            <h3 class="sub-title">(一) 利用期間</h3>
            <p>除法令另有規定者外，將於你使用克里奧數位網站內與其所附屬網站服務完畢或至您提出停止使用之請求為止。</p>
          </div>
          <div class="sub-section">
            <h3 class="sub-title">(二) 利用地區</h3>
            <p>台灣地區及提供克里奧數位網站內與其所附屬網站服務之地區。</p>
          </div>
          <div class="sub-section">
            <h3 class="sub-title">(三) 利用對象</h3>
            <p>
              除法令另有規定者外，將僅供你同意之服務目的及克里奧數位行銷有限公司內部在相關連之範圍內使用，不會任意將您提供的個人資料轉供其他第三人或移作其他目的使用。但基於履行契約目的，將提供相關資料予合作廠商，以完成履行契約義務。
            </p>
          </div>
          <div class="sub-section">
            <h3 class="sub-title">(四) 利用方式</h3>
            <p>
              <strong>會員資料：</strong
              >您在加入會員時所填寫的資料，克里奧數位將會進行手機及e-mail驗證，並作為分析您個人在站上與消費行為，以作為將來提供會員所需之詳盡資料以及作為設計會員活動時之依據。
            </p>
            <p>
              <strong>線上交易：</strong
              >如您選擇使用線上交易服務，將會依照你提出的線上交易形態，蒐集您所填寫的訂單相關資料，以確保您完成付款、儲值或物流等消費服務。
            </p>
            <p>
              <strong>線上活動及調查：</strong
              >您若因參加克里奧數位舉辦之線上活動或網路調查所留下的個人資料，僅供該次活動或調查使用。這些資料將於活動或調查結束後銷毀。
            </p>
            <p>
              <strong>統計與分析：</strong
              >克里奧數位針對您加入會員時所填寫的資料，以及站內瀏覽時伺服器所產生的紀錄，將不定期進行總體會員行為分析與統計，不會針對個人行為進行分析。
            </p>
          </div>
        </div>
      </div>

      <div class="protocol-section">
        <h2 class="section-title">四、您得行使的權利及方式</h2>
        <div class="section-content">
          <div class="sub-section">
            <h3 class="sub-title">(一) 權利項目</h3>
            <p>您就您的個人資料得向克里奧數位以書面請求行使以下權利：</p>
            <ol class="numbered-list">
              <li>查詢或請求閱覽。</li>
              <li>請求製給複製本。</li>
              <li>請求補充或更正。</li>
              <li>請求停止蒐集、處理或利用。</li>
              <li>請求刪除。</li>
            </ol>
          </div>
          <div class="sub-section">
            <h3 class="sub-title">(二) 權利限制</h3>
            <p>以上權利，若因您不符合克里奧數位申請程序或法令另有規定者外，將會受到限制。</p>
          </div>
          <div class="sub-section">
            <h3 class="sub-title">(三) 酌收費用</h3>
            <p>若您就您的個人資料向克里奧數位查詢、請求閱覽個人資料或製給複製本時，克里奧數位行銷有限公司將酌收必要成本費用。</p>
          </div>
          <div class="sub-section">
            <h3 class="sub-title">(四) 權利行使之方式</h3>
            <p>
              上開權利之申請，應填具申請文件，克里奧數位得向您請求提出可資確認之身分證明文件。若委託他人代為申請者，並應出具委任書，且提供本人及代理人之身分證明文件。
            </p>
          </div>
        </div>
      </div>

      <div class="protocol-section">
        <h2 class="section-title">五、若您無法提供完整的個人資料時，不提供將對您權益之影響</h2>
        <div class="section-content">
          <p>
            若您無法提供完整且確實的個人資料，將影響克里奧數位和您的聯繫、完成交易、提供服務、身份驗證或處理消費、交易或客訴問題。建議您應提供完整的個人資料及隨時更新。若因您未提供完整且確實個人資料，造成對您及第三人發生損害時，您應負擔一切責任，如造成克里奧數位的損失時，克里奧數位有權向您請求損害賠償。
          </p>
        </div>
      </div>

      <div class="protocol-section">
        <h2 class="section-title">六、個人資料安全維護</h2>
        <div class="section-content">
          <p>
            關於您的個人資料檔案，克里奧數位將採行適當之安全措施，並盡力以合理之技術及措施，依相關法令辦理安全維護事項，防止您的個人資料被竊取、竄改、毀損、滅失或洩漏。
          </p>
        </div>
      </div>

      <div class="protocol-section">
        <h2 class="section-title">七、隱私權政策的修改</h2>
        <div class="section-content">
          <p>
            克里奧數位有權自行修訂隱私權政策，相關修正規定將會公告於本網站，請您密切注意以保障個人權益。當您於隱私權政策任何修改或變更後繼續使用克里奧數位行銷有限公司網站與其所附屬之網站服務，表示您已閱讀、瞭解並同意接受隱私權政策修改或變更後之內容。
          </p>
          <p>如果您不同意本隱私權政策，請您立即停止使用克里奧數位網站與其所附屬之網站服務。</p>
        </div>
      </div>

      <div class="protocol-section">
        <h2 class="section-title">八、看法與建議</h2>
        <div class="section-content">
          <p>您如果對於克里奧數位隱私權政策或與個人資料有關之相關事項有任何意見或疑問，可以和克里奧數位客服中心聯絡。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  }
}
</script>

<style lang="less" scoped>
.protocol-container {
  padding: 20px;
  background-color: #f8f9fa;
  min-height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

.protocol-header {
  text-align: center;
  padding: 20px 0 30px;
  border-bottom: 2px solid #e0e0e0;
  margin-bottom: 24px;

  .protocol-title {
    font-size: 22px;
    font-weight: 600;
    color: #1a1a1a;
    margin: 0 0 10px;
    letter-spacing: 2px;
  }

  .protocol-subtitle {
    font-size: 18px;
    font-weight: 500;
    color: #666;
    margin: 0;
  }
}

.protocol-intro {
  background-color: #ffffff;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);

  p {
    font-size: 14px;
    line-height: 1.8;
    color: #333;
    margin: 0;
  }
}

.protocol-section {
  background-color: #ffffff;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);

  .section-title {
    font-size: 16px;
    font-weight: 600;
    color: #1890ff;
    margin: 0 0 16px;
    padding-bottom: 12px;
    border-bottom: 1px solid #e8e8e8;
  }

  .section-content {
    p {
      font-size: 14px;
      line-height: 1.8;
      color: #333;
      margin: 0 0 12px;
      text-align: justify;

      &:last-child {
        margin-bottom: 0;
      }
    }

    .sub-section {
      margin-bottom: 16px;

      &:last-child {
        margin-bottom: 0;
      }

      .sub-title {
        font-size: 14px;
        font-weight: 600;
        color: #333;
        margin: 0 0 10px;
      }
    }

    .numbered-list {
      margin: 12px 0;
      padding-left: 24px;

      li {
        font-size: 14px;
        line-height: 1.8;
        color: #333;
        margin-bottom: 8px;
        text-align: justify;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}

.privacy-policy {
  margin-top: 32px;

  .policy-header {
    background-color: #fff7e6;
    padding: 20px;
    border-radius: 8px;
    margin-bottom: 24px;
    border: 1px solid #ffd591;

    .policy-title {
      font-size: 18px;
      font-weight: 600;
      color: #fa8c16;
      margin: 0 0 12px;
    }

    .policy-intro {
      font-size: 14px;
      line-height: 1.8;
      color: #333;
      margin: 0;
    }
  }
}
</style>
